<template>
  <div class="report">
    <HeadBar /><!--顶部bar-->
    <HeadNav /><!-- 顶部导航-->
    <div class="report-container">
      <iframe
        src="http://www.xn--ruq948cu5a6yj.cn/entrust/lodingEntrust"
        width="100%"
        height="100%"
        frameborder="0"
        leftmargin="0"
        topmargin="0"
        onscroll="true"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.report {
  &-container {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
}
</style>
